import type { Testimonial } from '../types/content';
export const stats = [['4', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para aplicar']];
export const testimonials: Testimonial[] = [{
  name: 'Laura M.',
  place: 'Buenos Aires',
  quote: 'Antes una pavada podía quedarse horas en mi cabeza. Ahora tengo una forma concreta de cortar antes ese círculo y seguir con mi día.'
}, {
  name: 'Javier P.',
  place: 'Córdoba',
  quote: 'Me pasaba mucho con conversaciones y mensajes. El tema terminaba, pero yo seguía repasándolo mentalmente. Los protocolos me ayudaron a cerrar antes.'
}, {
  name: 'Sofía R.',
  place: 'Rosario',
  quote: 'Lo que más me sirvió fue aprender a separar lo que depende de mí de lo que ya está en manos de otros. Me evita gastar energía esperando o intentando controlar todo.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Agustina V.',
  place: 'Mendoza',
  quote: 'Las respuestas preparadas para conversaciones fueron de lo más útil. Cuando necesito poner un límite ya no tengo que pensar durante media hora cómo decirlo.'
}, {
  name: 'Martín G.',
  place: 'La Plata',
  quote: 'Yo podía pasar muchísimo tiempo dudando si escribir, esperar o insistir. Los árboles de decisión me ayudan a definirlo y dejar de revisar el tema.'
}, {
  name: 'Carolina D.',
  place: 'Neuquén',
  quote: 'Me llevaba problemas del trabajo y conversaciones del día a la cama. El cierre nocturno me ayudó a marcar un punto y decir: por hoy, esto termina acá.'
}, {
  name: 'Federico B.',
  place: 'Mar del Plata',
  quote: 'Me gustó que no haya que sentarse una hora a hacer ejercicios. Hay momentos en los que uso un protocolo de tres minutos y ya sé cuál es el siguiente paso.'
}];
